import Resizer from "react-image-file-resizer";

/**
 * Resize avatar image
 *
 * @param image
 * @returns both big and small resized avatar images
 */
function resizeAvatarImage(image: Blob): Promise<{ bigAvatarImg: Blob; smallAvatarImg: Blob }> {
  return new Promise((resolve) => {
    // Resize and compress image
    Resizer.imageFileResizer(
      image,
      600,
      600,
      "JPEG",
      50,
      0,
      async (res) => {
        const bigAvatarImg = res as Blob;

        Resizer.imageFileResizer(
          image,
          96,
          96,
          "JPEG",
          50,
          0,
          async (smallAvatarImg) => {
            resolve({ bigAvatarImg, smallAvatarImg: smallAvatarImg as Blob });
          },
          "blob"
        );
      },
      "blob"
    );
  });
}

export default resizeAvatarImage;
